var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactResizeDetector from 'react-resize-detector/build/withPolyfill';
import { propChildren, propFunc } from '@/helpers/custom-prop-types';
/**
 * 要素のリサイズを検知するライブラリのラッパーコンポーネント
 * @deprecated 以降はTS化した @/components/functional/Resize/ResizeDetector の方を参照してください
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ResizeDetectorComponent = (props) => {
    const { children, onResize } = props, otherProps = __rest(props, ["children", "onResize"]);
    return (_jsx(ReactResizeDetector, Object.assign({ onResize: onResize }, otherProps, { children: children })));
};
ResizeDetectorComponent.propTypes = {
    children: propChildren(),
    onResize: propFunc().isRequired,
};
ResizeDetectorComponent.defaultProps = {
    children: null,
};
export default ResizeDetectorComponent;
